import {
    DAYS,
    getHourTimeString,
    isTimeAllDay,
    parseDate,
    sameDateWithoutTime,
    setTimeByString
} from "../../../Common/Date/DateHelper";
import DateService from "../../../Common/Date/DateService";
import HoursHelper from "./HoursHelper";
import {ConfigHoursApi} from "../../../Api/types";

class AvailableHelper {

    static getAvailability(availabilities: any, id: any) {
        let obj = availabilities.filter((availability: any) => availability.id === id);
        if (obj.length > 0) {
            return obj[0];
        }
        return undefined;
    }

    static getAvailabilities(availabilities: any, ids: any) {
        let obj = availabilities.filter((availability: any) => ids.includes(availability.id));
        return obj;
    }

    static geDateAvailableAvailabilities(availabilities: any, ids: any, date: Date) {
        let obj = availabilities
            .filter((availability: any) => ids.includes(availability.id))
            .filter((availability: any) => !availability.dates.length || availability.dates.some((dateAvailability: any) => {
                return new Date(dateAvailability.date_from).getTime() <= date.getTime()
                    && new Date(dateAvailability.date_to).getTime() >= date.getTime();
            }))
        return obj;
    }

    static isAvailabileDate(availability: any, date: any, compareDateToOrEqual?: boolean) {
        if (availability) {
            if (availability.dates === undefined || availability.dates.length === 0) {
                return true;
            }
            let isAvailable = false;
            availability.dates.forEach((availabilityDate: any) => {
                const compareDateTo = parseDate(availabilityDate.date_to);
                if (compareDateTo.getTime() === parseDate(availabilityDate.date_from).getTime()) {
                    compareDateTo.setDate(compareDateTo.getDate() + 1);
                }

                if (date >= parseDate(availabilityDate.date_from) &&
                    (compareDateToOrEqual ? date <= compareDateTo : date < compareDateTo)) {
                    isAvailable = true;
                    return isAvailable;
                }
            });
            return isAvailable;
        }
        return true;
    }

    static isAvailabileHours(availability: any, date: any, compareDateToOrEqual?: boolean) {
        if (!availability) {
            return false;
        }
        if (!HoursHelper.isOpen(availability.hours, date, compareDateToOrEqual)) {
            return false;
        }
        return true;
    }

    static isAvailabile(availability: any, date: any, compareDateToOrEqual?: boolean): boolean {
        if (!availability) {
            return true;
        }
        if (Array.isArray(availability)) {
            let availabilities = availability;
            if (availabilities.length === 0) return true;
            return availabilities.some((a: any) => this.isAvailabile(a, date));
        }
        if (!this.isAvailabileDate(availability, date, compareDateToOrEqual)) {
            return false;
        }
        if (!this.isAvailabileHours(availability, date, compareDateToOrEqual)) {
            return false;
        }
        return true;
    }

    static getFutureDates = (availability: any) => {
        let now = DateService.now();
        return availability.dates.map((date: any) => {
            return {
                date_from: parseDate(date.date_from),
                date_to: parseDate(date.date_to)
            }
        }).filter((date: any) => {
            return date.date_to > now;
        }).sort((a: any, b: any) => a.date_from - b.date_from)
        // .sort((a, b) => new Date(a.date_from) - new Date(b.date_from))
    }

    static getOpenHours = (availability: any, date: any) => {
        if (!availability) {
            return [];
        }
        let openHours = HoursHelper.getOpenHours(availability.hours, date) as any[];

        if (!availability.dates || availability.dates.length == 0) {
            return openHours;
        }

        let dateMin = new Date(date);
        dateMin.setHours(0, 0, 0, 0);

        let dateMax = new Date(date);
        dateMax.setHours(23, 59, 59, 999);

        let availabilityDates = availability.dates.map((availabilityDate: any) => {
            return {
                date_from: parseDate(availabilityDate.date_from),
                date_to: parseDate(availabilityDate.date_to)
            }
        }).filter((availabilityDate: any) => {
            return availabilityDate.date_from <= dateMin && availabilityDate.date_to >= dateMin
                || availabilityDate.date_from <= dateMax && availabilityDate.date_to >= dateMax
        });

        let hoursDates = availabilityDates.map((availabilityDate: any) => {
            let hours = {} as any
            if (sameDateWithoutTime(date, availabilityDate.date_from)) {
                hours.hour_from = (new Date(date));
                hours.hour_from.setHours(availabilityDate.date_from.getHours(), availabilityDate.date_from.getMinutes(), 0);
            } else {
                hours.hour_from = (new Date(date));
                hours.hour_from.setHours(0, 0, 0);
            }
            if (sameDateWithoutTime(date, availabilityDate.date_to)) {
                hours.hour_to = (new Date(date));
                hours.hour_to.setHours(availabilityDate.date_to.getHours(), availabilityDate.date_to.getMinutes(), 0);
            } else {
                hours.hour_to = (new Date(date));
                hours.hour_to.setHours(0, 0, 0);
            }
            return hours;
        })

        let newOpenHours = [] as any[];
        openHours.forEach(openHour => {
            let newDateFrom = undefined as any;
            let newDateTo = undefined as any;
            hoursDates.forEach((hourDate: any) => {
                if (!newDateFrom || newDateFrom > hourDate.hour_from) {
                    newDateFrom = hourDate.hour_from;
                }
                if (!newDateTo || newDateTo < hourDate.hour_to) {
                    newDateTo = hourDate.hour_to;
                }
            })
            let OpenHourDateFrom = setTimeByString(new Date(date), openHour.hour_from);
            if (isTimeAllDay(newDateFrom) || newDateFrom < OpenHourDateFrom) {
                newDateFrom = OpenHourDateFrom;
            }
            let OpenHourDateTo = setTimeByString(new Date(date), openHour.hour_to);
            if (isTimeAllDay(OpenHourDateTo)) OpenHourDateTo.setHours(23, 59, 59)
            if (isTimeAllDay(newDateTo) || newDateTo > OpenHourDateTo) {
                newDateTo = OpenHourDateTo;
            }
            if (newDateTo && newDateFrom) {
                newOpenHours.push({
                    hour_from: getHourTimeString(newDateFrom),
                    hour_to: getHourTimeString(newDateTo),
                    day_from: openHour.day_from,
                    day_to: openHour.day_to,
                })
            }

        })
        return newOpenHours;
    }

    static getHoursAvailable = (availabilities: any, date: any) => {
        let availableHours = [] as any[];
        if (!date) {
            return;
        }

        availabilities.forEach((availability: any) => {
            let openHours = AvailableHelper.getOpenHours(availability, date);

            openHours.forEach(openHour => {
                const availableHour = availableHours
                    .find(ah => HoursHelper.hourRangeOverlaps(ah.hour_from, ah.hour_to, openHour.hour_from, openHour.hour_to));

                if (availableHour === undefined) {
                    availableHours.push(openHour);
                } else {
                    const index = availableHours.indexOf(availableHour)
                    if (availableHour.hour_from > openHour.hour_from) {
                        availableHours[index].hour_from = openHour.hour_from;
                    }
                    if (availableHour.hour_to < openHour.hour_to) {
                        availableHours[index].hour_to = openHour.hour_to;
                    }
                }
            })
        })

        return [...new Set(availableHours.map(hour => JSON.stringify(hour)))].map(value => JSON.parse(value));
    }

    static getAllDates = (menus: any, availabilities: any) => {
        let dates = [] as any[];
        let isAlwaysAvailableMenu = false;
        menus.forEach((menu: any) => {
            if (!menu.pick_date) {
                return;
            }
            if (menu.availability_id) {
                let availability = AvailableHelper.getAvailability(availabilities, menu.availability_id);
                if (!availability || !availability.dates || availability.dates.length === 0) {
                    isAlwaysAvailableMenu = true;
                    return undefined;
                }
                if (availability && availability.dates && availability.dates.length > 0) {
                    availability.dates.forEach((date: any) => {

                        dates.push({
                            date_from: parseDate(date.date_from).setHours(0, 0, 0),
                            date_to: parseDate(date.date_to).setHours(23, 59, 59)
                        });
                    })
                }
            } else {
                isAlwaysAvailableMenu = true;
                return undefined;
            }
        });
        if (isAlwaysAvailableMenu) {
            return undefined;
        }
        return dates;
    }
    static getAllWeekDays = (menus: any, availabilities: any) => {
        let weekDays = [] as any[];

        for (let i = 0; i < menus.length; i++) {
            const menu = menus[i];
            if (!menu.pick_date) {
                break;
            }
            if (menu.availability_id) {
                const availability = AvailableHelper.getAvailability(availabilities, menu.availability_id);
                availability.hours.forEach((hour: any) => {
                    if (!weekDays.includes(hour.day_from)) {
                        weekDays.push(hour.day_from);
                    }
                })
            }
        }

        return weekDays;
    }

    static getDatesToPickDate = (date: any, availabilities: any, addMinutesForEstimate: any) => {
        let minTodayHour = 0;
        let minTodayMinute = 0;
        let dateWithAddExtraMinutes = date;
        // let dateWithAddExtraMinutes = new Date(date.getTime() + 30 * 60000);
        minTodayHour = dateWithAddExtraMinutes.getHours();
        minTodayMinute = dateWithAddExtraMinutes.getMinutes();
        var arr = [];

        let max = 23;

        // let hours = AvailableHelper.getHoursAvailable(availabilities, DateHelper.fromString(date + " 00:00:00"));
        let hours = AvailableHelper.getHoursAvailable(availabilities, date);
        var minTime = hours && hours.length > 0 ? hours.reduce((a, b) => a.hour_from > b.hour_from ? a : b).hour_from : undefined;
        var maxTime = hours && hours.length > 0 ? hours.reduce((a, b) => a.hour_to > b.hour_to ? a : b).hour_to : undefined;
        var minHours = minTime ? parseInt(minTime.split(":")[0]) : 0;
        var maxHours = maxTime ? parseInt(maxTime.split(":")[0]) - 1 : 23;
        var minMinutes = minTime ? parseInt(minTime.split(":")[1]) : 0;
        var maxMinutes = maxTime ? parseInt(maxTime.split(":")[1]) : 59;
        if (maxHours <= 0) {
            maxHours = 23;
        }
        if (maxMinutes === 0) {
            maxMinutes = 59;
        }
        if (addMinutesForEstimate > 0) {
            minMinutes = minMinutes + addMinutesForEstimate;
            if (minMinutes >= 60) {
                const extraHours = Math.floor(minMinutes / 60);
                minHours += extraHours;
                minMinutes %= 60; // Keep the remaining minutes less than 60
            }
        }

        if (minHours < minTodayHour || (minHours === minTodayHour && minMinutes < minTodayMinute)) {
            minHours = minTodayHour;
            minMinutes = minTodayMinute;
        }
        maxHours = maxHours <= max ? maxHours : max;
        const createDate = (date: any, hours: any, minutes: any) => {
            let dateTmp = new Date(date.getTime());
            dateTmp.setHours(hours);
            dateTmp.setMinutes(minutes);
            dateTmp.setSeconds(0);
            return dateTmp;
        }
        for (let i = minHours; i <= maxHours; i++) {
            let iS = HoursHelper.getTime(i);
            if (HoursHelper.isMinuteAvailable(i, minHours, maxHours, minMinutes, maxMinutes, 0)) {
                arr.push(createDate(dateWithAddExtraMinutes, iS, 0))
            }
            if (HoursHelper.isMinuteAvailable(i, minHours, maxHours, minMinutes, maxMinutes, 15)) {
                arr.push(createDate(dateWithAddExtraMinutes, iS, 15))
            }
            if (HoursHelper.isMinuteAvailable(i, minHours, maxHours, minMinutes, maxMinutes, 30)) {
                arr.push(createDate(dateWithAddExtraMinutes, iS, 30))
            }
            if (HoursHelper.isMinuteAvailable(i, minHours, maxHours, minMinutes, maxMinutes, 45)) {
                arr.push(createDate(dateWithAddExtraMinutes, iS, 45))
            }
        }

        return arr;
    }
    static getAddMinutesToPickDateFromNow = (orderType: any, estimated_preparation_duration: any, estimated_delivery_duration: any) => {
        let todayWithMinStoreMinutes = DateService.now();
        let allAddEstimatedMinutes = AvailableHelper.getAddMinutesToPickDate(orderType, estimated_preparation_duration, estimated_delivery_duration);
        todayWithMinStoreMinutes = new Date(todayWithMinStoreMinutes.getTime() + (allAddEstimatedMinutes) * 60000);
        return todayWithMinStoreMinutes;
    }
    static getAddMinutesToPickDate = (orderType: any, estimated_preparation_duration: any, estimated_delivery_duration: any) => {
        let allAddEstimatedMinutes = 0;
        if (estimated_preparation_duration) allAddEstimatedMinutes += estimated_preparation_duration;
        if (orderType == "DELIVERY") {
            if (estimated_delivery_duration) allAddEstimatedMinutes += estimated_delivery_duration;
        }
        return allAddEstimatedMinutes;
    }

    static getNearestOpenDateFromNowOrDate = (menuAvailabilities: any, overrideDate?: Date, includeToday?: boolean, maxDateToSearch?: Date): {
        dateFrom: Date;
        dateTo: Date;
    } | undefined => {
        let nearestDateFrom = undefined;
        let nearestDateTo = undefined;
        let date = overrideDate ? new Date(overrideDate) : new Date();
        const searchingDate: Date = overrideDate ? new Date(overrideDate) : DateService.now();
        const maxDaysToSearch = 31;
        let searchingDay = 0;

        if (maxDateToSearch) {
            maxDateToSearch.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());

            if (maxDateToSearch.getTime() < date.getTime()) {
                return undefined;
            }
        }

        while (!nearestDateFrom) {
            menuAvailabilities.forEach((a: any) => {
                const hours = AvailableHelper.getOpenHours(a, date);
                if (hours.length) {
                    hours.forEach((hour: any) => {
                        const minHourFrom = hour.hour_from || undefined;
                        const minHourTo = hour.hour_to || undefined;

                        if (minHourFrom && minHourTo) {
                            const hourFrom = minHourFrom.split(":")[0];
                            const minuteFrom = minHourFrom.split(":")[1];
                            const compareDateFrom = new Date(
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                                hourFrom,
                                minuteFrom);

                            const hourTo = minHourTo.split(":")[0];
                            const minuteTo = minHourTo.split(":")[1];

                            const compareDateTo = new Date(
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                                hourTo,
                                minuteTo);

                            if (minHourFrom >= minHourTo) {
                                compareDateTo.setDate(compareDateTo.getDate() + 1);
                            }

                            if (includeToday && compareDateFrom.getTime() <= searchingDate.getTime() && compareDateTo.getTime() > searchingDate.getTime()) {
                                nearestDateFrom = compareDateFrom;
                                nearestDateTo = compareDateTo
                            } else if (compareDateFrom.getTime() > searchingDate.getTime()) {
                                nearestDateFrom = compareDateFrom;
                                nearestDateTo = compareDateTo
                            }
                        }
                    })
                }
            });

            if (nearestDateFrom) break;
            date.setDate(date.getDate() + 1);
            searchingDay++;
            if (searchingDay > maxDaysToSearch) {
                break;
            }
        }

        if (nearestDateFrom && nearestDateTo) return {dateFrom: nearestDateFrom, dateTo: nearestDateTo};
        return undefined;
    }

    static trimHoursToAvailabilities(availabilities: any[], date: any) {
        for (const a of availabilities) {
            const hours = AvailableHelper.getOpenHours(a, date.dateFrom);
            const availabilityFromHours = hours
                .filter(h => HoursHelper.getDayOfWeekNumber(h.day_from) === date.dateFrom.getDay())
                ?.map((h: any) => (h.hour_from))
                .sort((a: any, b: any) => HoursHelper.timeToMinutes(a) - HoursHelper.timeToMinutes(b))
            const smallestAvailabilityHour = availabilityFromHours?.[0];
            const availabilityToHours = hours
                .filter(h => HoursHelper.getDayOfWeekNumber(h.day_from) === date.dateFrom.getDay())
                ?.map((h: any) => (h.hour_to))
                .sort((a: any, b: any) => HoursHelper.timeToMinutes(b === '00:00' ? '24:00' : b) - HoursHelper.timeToMinutes(a === '00:00' ? '24:00' : a));
            const largestAvailabilityHour = availabilityToHours?.[0];
            const fullDay = isTimeAllDay(date.dateFrom) && isTimeAllDay(date.dateTo);

            if (!AvailableHelper.isAvailabile(a, new Date(date.dateFrom))) {
                if (smallestAvailabilityHour) {
                    const hour = smallestAvailabilityHour.split(':')[0];
                    const minute = smallestAvailabilityHour.split(':')[1];
                    const compareDate = new Date(date.dateFrom);
                    compareDate.setHours(hour, minute, 0, 0);
                    const beforeCompare =
                        date.dateTo &&
                        date.dateFrom < compareDate &&
                        date.dateTo < compareDate;

                    if (!beforeCompare && (date.dateFrom < compareDate || fullDay)) {
                        date.dateFrom.setHours(hour, minute, 0, 0);
                        if (fullDay) {
                            date.dateTo.setDate(date.dateFrom.getDate() - 1);
                        }
                    }
                }
            }

            if (largestAvailabilityHour) {
                const hour = largestAvailabilityHour.split(':')[0];
                const minute = largestAvailabilityHour.split(':')[1];
                if (!date.dateTo) {
                    date.dateTo = new Date(date.dateFrom);
                    date.dateTo.setHours(hour, minute, 0, 0);
                } else {
                    const compareDate = new Date(date.dateTo);
                    compareDate.setHours(hour, minute, 0, 0);
                    const shouldSetHours =
                        date.dateTo > compareDate ||
                        fullDay ||
                        (date.dateTo < date.dateFrom && date.dateFrom < compareDate);
                    if (shouldSetHours) {
                        date.dateTo.setHours(hour, minute, 0, 0);
                    }
                }
            }
        }
    };

    static checkIfDateIsInStoreAndMenu(storeOpenHours: ConfigHoursApi[], menuAvailabilitiesForType: any, date: Date) {
        return HoursHelper.isOpen(storeOpenHours, date, true)
            && (menuAvailabilitiesForType.some((a: any) => AvailableHelper.isAvailabile(a, date)) || menuAvailabilitiesForType.length === 0);
    }

    static getFullOpeningInfo = (availability: Record<string, any>) => {
        const hours: ConfigHoursApi[] = availability.hours;
        const dates: { date_from: Date, date_to: Date }[] = availability.dates;

        if (!dates || dates.length === 0) {
            return hours.map((h) => ({
                day: h.day_from,
                hour_from: h.hour_from,
                hour_to: h.hour_from === h.hour_to ? '00:00' : h.hour_to
            }));
        }

        const result: { date_from: Date, date_to: Date }[] = [];

        dates.forEach((d) => {
            const start = parseDate(d.date_from);
            const end = parseDate(d.date_to);

            let trimmedStart = new Date(start);
            let trimmedEnd = new Date(end);

            const startDayName = DAYS[start.getDay()];
            const endDayName = DAYS[end.getDay()];

            const startHours = hours.find(h => h.day_from === startDayName);
            const endHours = hours.find(h => h.day_from === endDayName);

            let finalStartMinutes = start.getHours() * 60 + start.getMinutes();
            let finalEndMinutes = end.getHours() * 60 + end.getMinutes();

            if (startHours) {
                let baseFrom = HoursHelper.timeToMinutes(startHours.hour_from);
                let baseTo = HoursHelper.timeToMinutes(startHours.hour_to);
                if (baseFrom === baseTo) baseTo = 24 * 60;

                finalStartMinutes = Math.max(baseFrom, finalStartMinutes);
                if (finalStartMinutes >= baseTo) return;
            }

            if (endHours) {
                let baseFrom = HoursHelper.timeToMinutes(endHours.hour_from);
                let baseTo = HoursHelper.timeToMinutes(endHours.hour_to);
                if (baseFrom === baseTo) baseTo = 24 * 60;

                finalEndMinutes = Math.min(baseTo, finalEndMinutes);
                if (finalEndMinutes <= baseFrom) return;
            }

            if (finalStartMinutes < finalEndMinutes) {
                trimmedStart.setHours(Math.floor(finalStartMinutes / 60), finalStartMinutes % 60, 0, 0);
                trimmedEnd.setHours(Math.floor(finalEndMinutes / 60), finalEndMinutes % 60, 0, 0);

                result.push({
                    date_from: trimmedStart,
                    date_to: trimmedEnd
                });
            }
        });

        return result;
    };

}

export default AvailableHelper;